import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface VirtualAtonHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

export const VirtualAtonHoverLabels = ({
  form,
}: VirtualAtonHoverLabelsProps) => {
  const { messages } = useLocalization();

  const VIRTUALATON_HOVER_FIELDS = [
    { name: 'virtualaton_mmsi', label: messages.settingsMapVirtualAtonHoverMmsiLabel, description: messages.settingsMapVirtualAtonHoverMmsiDescription },
    { name: 'virtualaton_country', label: messages.settingsMapVirtualAtonHoverCountryLabel, description: messages.settingsMapVirtualAtonHoverCountryDescription },
    { name: 'virtualaton_latitude', label: messages.settingsMapVirtualAtonHoverLatitudeModeLabel, description: messages.settingsMapVirtualAtonHoverLatitudeDescription },
    { name: 'virtualaton_longitude', label: messages.settingsMapVirtualAtonHoverLongitudeLabel, description: messages.settingsMapVirtualAtonHoverLongitudeDescription },
    { name: 'virtualaton_assignedMode', label: messages.settingsMapVirtualAtonHoverAssignedModeLabel, description: messages.settingsMapVirtualAtonHoverAssignedModeDescription },
    { name: 'virtualaton_virtualAtonType', label: messages.settingsMapVirtualAtonHoverVirtualAtonTypeLabel, description: messages.settingsMapVirtualAtonHoverVirtualAtonTypeDescription },
    { name: 'virtualaton_length', label: messages.settingsMapVirtualAtonHoverLengthLabel, description: messages.settingsMapVirtualAtonHoverLengthDescription },
    { name: 'virtualaton_offPosition', label: messages.settingsMapVirtualAtonHoverOffPositionModeLabel, description: messages.settingsMapVirtualAtonHoverOffPositionDescription },
    { name: 'virtualaton_state', label: messages.settingsMapVirtualAtonHoverStateLabel, description: messages.settingsMapVirtualAtonHoverStateDescription },
    { name: 'virtualaton_status', label: messages.settingsMapVirtualAtonHoverStatusLabel, description: messages.settingsMapVirtualAtonHoverStatusDescription },
    { name: 'virtualaton_width', label: messages.settingsMapVirtualAtonHoverWidthLabel, description: messages.settingsMapVirtualAtonHoverWidthDescription },
    { name: 'virtualaton_virtualAtonTargetType', label: messages.settingsMapVirtualAtonHoverTargetTypeLabel, description: messages.settingsMapVirtualAtonHoverTargetTypeDescription },
  ] as const;

  return (
    <div className="grid grid-cols-2 gap-4">
      {VIRTUALATON_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
